import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getDeliveryZoneHeader = id =>
  axios({
    method: 'get',
    url: `${publicAPI}/deliveryzone/${id}/header`,
  });
